var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { fromEvent, timer } from 'rxjs';
import { Flicker } from '@flexem/fc-gui';
import { IndicatorLightType } from '../../../diagram/utils/indicator-light/indicator-light-type';
import { IndicatorLightHelper } from '../../../diagram/utils/indicator-light/indicator-light-helper';
import { WordIndicatorLightCondition } from '../../../diagram/utils/indicator-light/word-indicator-light-condition';
import { BitIndicatorLightCondition } from '../../../diagram/utils/indicator-light/bit-indicator-light-condition';
import { map, debounce } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var StateComponent = /** @class */ (function (_super) {
    __extends(StateComponent, _super);
    function StateComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.flicker = Flicker;
        _this.indicatorLightHelper = IndicatorLightHelper;
        _this.preConditionOperand = 0;
        _this.useSwitch = false;
        _this.useIndicatorLight = false;
        _this.indicatorLightType = IndicatorLightType.Bit;
        _this.bitIndicatorLightConditions = IndicatorLightHelper.getBitIndicatorLightConditions();
        _this.wordIndicatorLightConditions = IndicatorLightHelper.getWordIndicatorLightConditions();
        _this.flickers = IndicatorLightHelper.getFlickers();
        return _this;
    }
    StateComponent.prototype.ngOnInit = function () {
        var _this = this;
        // TODO use lettable operators instead.https://hackernoon.com/rxjs-reduce-bundle-size-using-lettable-operators-418307295e85
        fromEvent(this.stateCountInput.nativeElement, 'change').pipe(map(function (event) {
            var eventArg = event;
            // eslint-disable-next-line no-new-wrappers
            var inputValue = new Number(eventArg.currentTarget.value).valueOf();
            // eslint-disable-next-line no-new-wrappers
            var minValue = new Number(eventArg.currentTarget.min).valueOf();
            // eslint-disable-next-line no-new-wrappers
            var maxValue = new Number(eventArg.currentTarget.max).valueOf();
            if (inputValue > maxValue) {
                return maxValue;
            }
            else if (inputValue < minValue) {
                return minValue;
            }
            else {
                return inputValue;
            }
        }), debounce(function () { return timer(200); }))
            .subscribe(function (value) { return _this.stateCount = value; });
    };
    StateComponent.prototype.ngOnDestroy = function () {
        this.indicatorLightType = IndicatorLightType.Bit;
    };
    Object.defineProperty(StateComponent.prototype, "editedState", {
        get: function () {
            return this.editedStateValue ? this.editedStateValue : this.editedStates[0];
        },
        set: function (value) {
            this.editedStateValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateComponent.prototype, "bitConditionLogic", {
        get: function () {
            if (this.useIndicatorLight && IndicatorLightType.Bit === this.indicatorLightType) {
                if (this.editedStates.length === 2) {
                    return BitIndicatorLightCondition.Off === this.editedStates[0].condition.operator &&
                        BitIndicatorLightCondition.On === this.editedStates[1].condition.operator;
                }
            }
            return false;
        },
        set: function (value) {
            if (this.useIndicatorLight && IndicatorLightType.Bit === this.indicatorLightType) {
                if (this.editedStates.length === 2) {
                    this.editedStates[0].condition.operator = value ? BitIndicatorLightCondition.Off : BitIndicatorLightCondition.On;
                    this.editedStates[1].condition.operator = !value ? BitIndicatorLightCondition.Off : BitIndicatorLightCondition.On;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateComponent.prototype, "stateCountEnabled", {
        get: function () {
            return this.useIndicatorLight && IndicatorLightType.Word === this.indicatorLightType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateComponent.prototype, "isBitIndicatorLight", {
        get: function () {
            return IndicatorLightType.Bit === this.indicatorLightType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateComponent.prototype, "stateCount", {
        get: function () {
            return this.editedStates.length;
        },
        set: function (value) {
            if (!this.stateCountEnabled) {
                this.editedState = [];
                return;
            }
            if (this.editedStates) {
                this.changeStates(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    StateComponent.prototype.changeStates = function (stateCount) {
        var difference = this.editedStates.length - stateCount;
        if (difference > 0) {
            var errorState = this.editedStates.pop();
            this.editedStates.splice(stateCount - 1, difference);
            this.editedStates.push({
                id: stateCount - 1,
                text: errorState.text
            });
        }
        else if (difference < 0) {
            var errorState = this.editedStates.pop();
            for (var i = difference; i < 0; i++) {
                this.editedStates.push({
                    id: stateCount + i - 1,
                    condition: { operator: WordIndicatorLightCondition.Equal, operand: stateCount + i - 1 },
                    text: IndicatorLightHelper.getDefaultLabel(),
                    faultFlicker: _.cloneDeep(IndicatorLightHelper.defaultFaultFlicker)
                });
            }
            this.editedStates.push({
                id: stateCount - 1,
                text: errorState.text
            });
        }
    };
    Object.defineProperty(StateComponent.prototype, "editedStates", {
        get: function () {
            var states;
            if (this.useIndicatorLight) {
                if (IndicatorLightType.Bit === this.indicatorLightType) {
                    states = this.stateSettings.bitIndicatorLightStates;
                }
                else {
                    states = this.stateSettings.wordIndicatorLightStates;
                }
            }
            else {
                return this.stateSettings.switchStates;
            }
            states.forEach(function (state) {
                if (!state.faultFlicker) {
                    state.faultFlicker = _.cloneDeep(IndicatorLightHelper.defaultFaultFlicker);
                }
            });
            return states;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateComponent.prototype, "conditions", {
        get: function () {
            if (IndicatorLightType.Bit === this.indicatorLightType) {
                return this.bitIndicatorLightConditions;
            }
            else {
                return this.wordIndicatorLightConditions;
            }
        },
        enumerable: true,
        configurable: true
    });
    StateComponent.prototype.getStatusConditionText = function (state) {
        if (!state || !this.useIndicatorLight) {
            return '';
        }
        if (IndicatorLightType.Bit === this.indicatorLightType) {
            return IndicatorLightHelper.getBitIndicatorLightCondition(state.condition);
        }
        else {
            return IndicatorLightHelper.getWordIndicatorLightCondition(state.condition) + state.operand;
        }
    };
    StateComponent.prototype.validateFrequency = function (currentFormControl) {
        var frequencyControl = currentFormControl.parent.controls['Frequency'];
        if (!frequencyControl) {
            return undefined;
        }
        if (frequencyControl.value <= 0) {
            return { 'nonNegativeNumber': true };
        }
        return undefined;
    };
    StateComponent.prototype.validateConditionOperand = function () {
        if (_.isNil(this.editedState.condition.operand)) {
            this.editedState.condition.operand = this.preConditionOperand;
        }
    };
    __decorate([
        Input()
    ], StateComponent.prototype, "useSwitch", void 0);
    __decorate([
        Input()
    ], StateComponent.prototype, "useIndicatorLight", void 0);
    __decorate([
        Input()
    ], StateComponent.prototype, "indicatorLightType", void 0);
    __decorate([
        Input()
    ], StateComponent.prototype, "stateSettings", void 0);
    __decorate([
        ViewChild('stateCountInput', { static: true })
    ], StateComponent.prototype, "stateCountInput", void 0);
    StateComponent = __decorate([
        Component({
            selector: 'state',
            styles: ["table,th,td{ border: 0; } .state-number{ width: 100%; line-height: 30px; font-size: 14px; color: #333333; .state-tool-tip{ font-size: 12px; color: #999999; margin-left: 10px; } input[type=number]{ width: 80px; height: 30px; } } .stateTable.table-scrollable { height: 180px; border:1px solid #d7dbe5; text-align: center; word-wrap: break-word; width: 100%; background: #F2F3F8; margin-top: 6px; table > thead > tr{ color: #333333; th{ padding: 0; line-height: 30px; border-bottom: 1px solid #d7dbe5; } } .dataTables_scrollBody{ border-bottom: none; height: 150px; overflow-y: scroll; table > tbody > tr { color: #666666; td{ padding: 0; line-height: 29px; border-bottom: 1px solid #d7dbe5; } } table > tbody > tr:nth-child(1){ td{ line-height: 30px; } } max-height: 150px; overflow-y: auto; } } table{ width: 100%; } tr.selected{ background-color: #3695ff; } tr.selected>td{ color:#ffffff!important; border-bottom: 1px solid #3695ff!important; } th.disabled { color: #999; } .editedState{ margin-top: 10px; background: #f2f3f8; border: 0; } .state-radio{ width: 30%; } .font-style{ margin-left: 105px; } .condition-select,.condition-input{ width: 90px; float: left; } .condition-input{ margin-left: 10px; } .noResize { resize: none; } .whole-width{ width: 100%; } textarea{ float: left; width: calc(100% - 105px); height: 150px; line-height: 20px; }"],
            template: "<div provide-parent-forms> <div class=\"state-number\"> {{lc(\"StateNumber\")}}： <input #stateCountInput type=\"number\" name=\"StateCount\" class=\"\" [ngModel]=\"stateCount\" [readonly]=\"!stateCountEnabled\" min=\"2\" max=\"255\"> <span class=\"state-tool-tip\">{{lc(\"StateWarning\")}}</span> </div> <div> <div class=\"table-scrollable dataTables_scroll stateTable\"> <div class=\"dataTables_scrollHeadInner\"> <table> <thead> <tr> <th width=\"14%\">{{lc(\"State\")}}</th> <th width=\"29%\" [class.disabled]=\"!useIndicatorLight\">{{lc(\"Condition\")}}</th> <th width=\"29%\">{{lc(\"Label\")}}</th> <th width=\"14%\" [class.disabled]=\"!useIndicatorLight\">{{lc(\"Flicker\")}}</th> <th width=\"14%\" [class.disabled]=\"!useIndicatorLight\">{{lc(\"Frequency\")}}</th> </tr> </thead> </table> </div> <div class=\"dataTables_scrollBody\"> <table> <tbody> <tr *ngFor=\"let state of editedStates\" (click)=\"editedState = state\" [class.selected]=\"editedState&&state.id==editedState.id\"> <td width=\"14%\">{{state.id|stateId:useSwitch:useIndicatorLight}}</td> <td width=\"29%\"> <span *ngIf=\"state.condition\">{{state.condition.operator|stateCondition:useIndicatorLight:indicatorLightType:state.condition.operand}}</span> <span *ngIf=\"!state.condition&&useIndicatorLight\">{{lc(\"Other\")}}</span> </td> <td width=\"29%\" style=\"max-width: 150px;line-height: 20px;\">{{state.text.content}}</td> <td width=\"14%\">{{lc(indicatorLightHelper.getFlickerName(state?.faultFlicker?.flicker))}}</td> <td width=\"14%\" *ngIf=\"state?.faultFlicker?.flicker === flicker.Nothing\">--</td> <td width=\"14%\" *ngIf=\"state?.faultFlicker?.flicker !== flicker.Nothing\">{{state?.faultFlicker?.frequency}}s</td> </tr> </tbody> </table> </div> </div> </div> <div *ngIf=\"editedState\" class=\"editedState fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title\">{{lc(\"State\")}}：</div> <div class=\"fe-transverse-component\">{{editedState.id}}</div> </div> <div class=\"fe-transverse-label  clearfix\" *ngIf=\"useIndicatorLight\"> <div *ngIf=\"isBitIndicatorLight\"> <div class=\"fe-transverse-title\"> {{lc(\"Condition\")}}： </div> <div class=\"fe-transverse-component\"> <label class=\"state-radio\"> <input type=\"radio\" name=\"BitCondition\" [value]=\"true\" [(ngModel)]=\"bitConditionLogic\" /> <span> {{lc('PositiveLogic')}} </span> </label> <label class=\"state-radio\"> <input type=\"radio\" name=\"BitCondition\" [value]=\"false\" [(ngModel)]=\"bitConditionLogic\" /> <span> {{lc('NegativeLogic')}} </span> </label> </div> </div> <div *ngIf=\"!isBitIndicatorLight&&editedState.condition\"> <div class=\"fe-transverse-title\"> {{lc(\"Condition\")}}： </div> <div class=\"fe-transverse-component clearfix\"> <select name=\"ConditionDropDown\" [(ngModel)]=\"editedState.condition.operator\" class=\"condition-select\"> <option *ngFor=\"let condition of conditions\" [ngValue]=\"condition.key\">{{condition.name}}</option> </select> <input type=\"number\" name=\"ConditionOperand\" [(ngModel)]=\"editedState.condition.operand\" class=\"condition-input\" (change)=\"validateConditionOperand()\"> </div> </div> </div> <div class=\"fe-transverse-label textToolBarPadding clearfix\"> <div class=\"fe-transverse-title\"> {{lc(\"Label\")}}: </div> <textarea class=\"noResize\" rows=\"6\" name=\"content\" #textInput maxlength=\"500\" [(ngModel)]=\"editedState.text.content\"> </textarea> <div class=\"fe-transverse-component font-style\"> <font-style [(fontSize)]=\"editedState.text.font.fontSize\" [(fontColor)]=\"editedState.text.font.color\" [(isUnderline)]=\"editedState.text.font.isUnderline\" [(fontStyle)]=\"editedState.text.font.fontStyle\" [(textAlign)]=\"editedState.text.font.textAlign\"></font-style> </div> </div> <div class=\"fe-transverse-label  clearfix\" *ngIf=\"useIndicatorLight&&editedState.faultFlicker\"> <div class=\"fe-half-line\"> <div class=\"fe-transverse-title\"> {{lc(\"Flicker\")}}: </div> <div class=\"fe-transverse-component\"> <select name=\"StateFlicker\" [(ngModel)]=\"editedState.faultFlicker.flicker\"> <option *ngFor=\"let flicker of flickers\" [ngValue]=\"flicker.key\">{{lc(flicker.name)}}</option> </select> </div> </div> <div class=\"fe-half-line\"> <div class=\"fe-transverse-title\"> {{lc(\"Frequency\")}}: </div> <div class=\"fe-transverse-component\"> <input *ngIf=\"editedState.faultFlicker.flicker === flicker.Nothing\" type=\"text\" value=\"--\" [disabled]=\"true\"> <div *ngIf=\"editedState.faultFlicker.flicker !== flicker.Nothing\"> <input type=\"number\" name=\"Frequency\" #Frequency=\"ngModel\" [(ngModel)]=\"editedState.faultFlicker.frequency\" [custom-func-validate]=\"validateFrequency\" required> <div class=\"has-danger\"> <div class=\"form-control-feedback\" *ngIf=\"Frequency.invalid && (Frequency.dirty || Frequency.touched)\"> <span *ngIf=\"Frequency.errors.required || Frequency.errors.nonNegativeNumber\"> {{l('MustBeThan0')}}</span> </div> </div> </div> </div> </div> </div> </div> </div>"
        })
    ], StateComponent);
    return StateComponent;
}(ConfigureComponentBase));
export { StateComponent };
